<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>TOKEN：</label>
                <el-input v-model="search_Obj.f_token" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>TOKEN：</label>
                <el-input v-model="search_Obj.f_vid" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>充值号：</label>
                <el-input v-model="search_Obj.f_recharge_sn" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>会员ID：</label>
                <el-input v-model="search_Obj.f_member_id" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="token" label="TOKEN" sortable="custom"></el-table-column>
                <el-table-column prop="yzm" label="验证码" sortable="custom"></el-table-column>
                <el-table-column prop="vid" label="VID" sortable="custom"></el-table-column>
                <el-table-column prop="member_id" label="会员ID" sortable="custom"></el-table-column>
                <el-table-column prop="recharge_sn" label="充值号" sortable="custom"></el-table-column>
                <el-table-column prop="state" label="状态" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.state, "online_state") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="temp" label="温度" sortable="custom"></el-table-column>
                <el-table-column prop="add_time" label="添加时间" sortable="custom"></el-table-column>
                <el-table-column prop="bind_time" label="绑定时间" sortable="custom"></el-table-column>
                <el-table-column prop="storage_total" label="存储容量(GB)" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ scope.row.storage_avail }}/{{ scope.row.storage_total }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="240" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看毛豆盒子"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"
import { unBind } from '@/api/mdhz'

export default {
    name: 'mdhzList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '毛豆盒子',
            menu_id: 10100,
            list_url: "/api/admin/mdhz/list",
            search_Obj: {
                f_token: '',
                f_vid: '',
                f_member_id: '',
                f_recharge_sn: '',
            },
            del_Obj:{
                url:'/api/admin/mdhz/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['online_state'],
        };
    },
    methods: {
        unBind(index, row) {
            this.$confirm('确定要解绑该设备吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                unBind(row.id).then(res => {
                    if (res.code == 1) {
                        this.$msgs(res.msg)
                        this.getListData();
                    } else {
                        this.$msg(res.msg)
                    }
                })
            }).catch(() => { })
        },
    }
};
</script>